import { CircleLoaderIcon } from "@smartsuite/react-ui/lib/components/loaders/CircleLoaderIcon/CircleLoaderIcon";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import { RefreshingListContainer } from "./style";

export const RefreshingList: React.FC = () => {
  return (
    <RefreshingListContainer>
      <CircleLoaderIcon iconColor="#B2B2B3" />
      <Text weight="medium" size="m" color="secondary">
        Refreshing List
      </Text>
    </RefreshingListContainer>
  );
};
